import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountCloseSuccessPage} from 'features/deposit/pages/DepositAccountCloseSuccessPage';

export const Route = createFileRoute(
  '/_protected/accounts/deposits/$accountId/close/success',
)({
  component: DepositAccountCloseSuccessPage,
});
